import { Link, ListItem, OrderedList, Text, UnorderedList } from "@chakra-ui/react"
import * as prismicH from "@prismicio/helpers"
import { PrismicRichText } from "@prismicio/react"
import { RTNode } from "@prismicio/types"
import CustomLink from "./CustomLink"

// Prismic docs -> https://prismic.io/docs/technical-reference/prismicio-react#prismicrichtext
// We are passing this components object with overrides for the HtML components.
// I have added the ones that are allowed at the moment in prismic and have given them chakra ui component so they have access to the theme object
const components = {
  paragraph: ({ children, key }) => <Text key={key}>{children}</Text>,
  listItem: ({ children, key }) => <ListItem key={key}>{children}</ListItem>,
  oListItem: ({ children, key }) => <ListItem key={key}>{children}</ListItem>,
  list: ({ children, key }) => (
    <UnorderedList key={key} marginInlineStart="8">
      {children}
    </UnorderedList>
  ),
  oList: ({ children, key }) => (
    <OrderedList key={key} marginInlineStart="8">
      {children}
    </OrderedList>
  ),
  hyperlink: ({ node, children, key }) => {
    return (
      <CustomLink key={key} href={node.data.url}>
        <Link fontWeight="medium" textDecoration="underline" target={node.data.target}>
          {children}
        </Link>
      </CustomLink>
    )
  },
}

type Props = {
  rtfValue: [] | [RTNode, ...RTNode[]]
}

const PrismicRtfLabel = ({ rtfValue }: Props) => {
  return <>{prismicH.isFilled.richText(rtfValue) && <PrismicRichText field={rtfValue} components={components} />}</>
}

export default PrismicRtfLabel
